export default "/_next/static/chunks/fonts/Raleway Regular-d9219d8a361ac3530c7e62150bca03b7.ttf";